export default {
  alignLeft: "左对齐",
  alignCenter: "居中对齐",
  alignRight: "右对齐",
  attachFiles: "附件",
  bold: "加粗",
  bullets: "无序列表",
  byte: "Byte",
  bytes: "Bytes",
  captionPlaceholder: "增加说明…",
  code: "代码",
  heading1: "标题1",
  highlight:'高亮',
  indent: "增加层级",
  italic: "斜体",
  link: "链接",
  numbers: "有序列表",
  outdent: "降低层级",
  quote: "引用",
  redo: "重做",
  remove: "Remove",
  save: "保存草稿",
  send: "邮件发送",
  carbonCopy:"抄送",
  blindCarbonCopy:"密送",
  strike: "删除线",
  undo: "撤销",
  unlink: "取消链接",
  url: "URL",
  urlPlaceholder: "输入链接URL…",
  GB: "GB",
  KB: "KB",
  MB: "MB",
  PB: "PB",
  TB: "TB",
}
